import TableSortLabel from '@mui/material/TableSortLabel';
import type { FC } from 'react';

import { SortDirection } from '../../DataTable.types';

interface SortableHeaderLabelProps {
    text: string;
    active?: boolean;
    direction?: SortDirection;
    onSort?: () => void;
}

export const SortableHeaderLabel: FC<SortableHeaderLabelProps> = ({
    text,
    active = false,
    direction = SortDirection.Asc,
    onSort,
}) => (
    <TableSortLabel
        active={active}
        direction={active ? direction : SortDirection.Asc}
        onClick={onSort}
    >
        {text}
    </TableSortLabel>
);
